import React from 'react'
import styles from './MultilineText.module.scss'

export const MultilineText = ({children}) => {
    return (
        <span className={styles.multiline}>{children}</span>
    )
}
